import React from 'react';

export class Check extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    createComponentClasses() {
        let {
            className,
            isSelector,
            isChecked,
        } = this.props;

        let classNames                      = ['marketkit-checkbox-wrapper-check'];
        if (isSelector)                     classNames.push('selector');
        if (isChecked)                      classNames.push('checked');
        if (className)                      Array.prototype.push.apply(classNames, className.split(' '));

        return [...new Set(classNames)].join(' ');
    }

    render() {
        const p = this.props;
        return (
            <div className   = { this.createComponentClasses() } >
                { p.children }
            </div>
        )
    }
}

export default Check;